export default __webpack_public_path__ + "static/media/OldStageDownClosed.a0f94b17.svg";